import React, { useState, useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  AppBar,
  Badge,
  Box,
  Hidden,
  IconButton,
  Toolbar
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/NotificationsOutlined';
import InputIcon from '@mui/icons-material/Input';

import Logo from './Logo';
import {signOutOfCloud} from 'src/DjangoAuth'
import { UserContext } from '../providers/UserProvider';

const useStyles = makeStyles(() => ({
  bar: {
    backgroundColor: '#72A5DC',
    padding: '10px',
    height: '90px'
  },
}));

const DashboardNavbar = ({ onMobileNavOpen, ...rest }) => {
  const classes = useStyles();
  const [notifications] = useState([]);
  const {user, setUser} = useContext(UserContext);

  const signOut = () => {
    signOutOfCloud(user);
    setUser({});
  };

  return (
    <AppBar
      elevation={1}
      {...rest}
    >
      <Toolbar className={classes.bar}>
        <RouterLink to="/">
          <Logo />
        </RouterLink>
        <Box sx={{ flexGrow: 1 }} />
        <Hidden lgDown>
          <IconButton color="primary">
            <Badge
              overlap="rectangular"
              badgeContent={notifications.length}
              color="secondary"
              variant="dot"
            >
              <NotificationsIcon />
            </Badge>
          </IconButton>
          <IconButton onClick={signOut} color="primary">
            <InputIcon />
          </IconButton>
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color="primary"
            onClick={onMobileNavOpen}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

DashboardNavbar.propTypes = {
  onMobileNavOpen: PropTypes.func
};

export default DashboardNavbar;
